module.exports = __webpack_public_path__ + "static/media/light-up-icon.3d747b08.svg";